// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-552a9430] .vs-popup {\n  width: 800px !important;\n}", ""]);
// Exports
module.exports = exports;
